export default "__VITE_ASSET__D_Zw_1lR__"